import {
  OLLIE_NOTICED_PAGES,
  ollieNoticedChecksFor,
  ollieNoticedTakesAnyCheck,
} from './ollieNoticedRows'

/** Quiet page entry — finding-backed when possible, never invents unsupported asks. */
export const OLLIE_CONTEXTUAL_ASK_LABEL = 'Ask Ollie about this'

/**
 * Verified page how-tos only (knowledge-base / page starters). Used when the
 * page has no live finding. Omit a page to hide the link until a finding
 * appears — do not advertise unsupported “about this order/invoice” asks.
 */
export const OLLIE_CONTEXTUAL_ASK_FALLBACKS = Object.freeze({
  [OLLIE_NOTICED_PAGES.RECEIPTING]: Object.freeze({
    question: 'How do I receipt a delivery and reconcile an invoice?',
    entryPoint: 'receipting',
  }),
  gross_profit: Object.freeze({
    question: 'How does the Gross Profit report work?',
    entryPoint: 'gross_profit',
  }),
  [OLLIE_NOTICED_PAGES.FOOD_SAFETY]: Object.freeze({
    question: 'What Food Safety checks are overdue?',
    entryPoint: 'food_safety',
  }),
})

/**
 * Pick the page's top finding that already has a served askOllie question.
 * Findings are Express-ranked and capability-filtered for this viewer.
 */
export function pickOllieContextualFinding(page, findings = []) {
  const wanted = ollieNoticedChecksFor(page)
  if (!wanted.length) return null
  const anyCheck = ollieNoticedTakesAnyCheck(page)
  return (
    (findings || []).find(finding => {
      if (!finding?.checkId || finding.kind === 'notice') return false
      if (!String(finding.askOllie?.question || '').trim()) return false
      return anyCheck || wanted.includes(finding.checkId)
    }) || null
  )
}

/**
 * Resolve a contextual Ask for this page.
 * Prefer the live finding (checkId + filled question); else a verified fallback.
 *
 * @returns {{
 *   label: string,
 *   question: string,
 *   checkId: string|null,
 *   entryPoint: string,
 *   finding: object|null,
 * } | null}
 */
export function resolveOllieContextualAsk({
  page = null,
  findings = [],
  fallback = null,
  label = OLLIE_CONTEXTUAL_ASK_LABEL,
} = {}) {
  const finding = page ? pickOllieContextualFinding(page, findings) : null
  if (finding) {
    return {
      label,
      question: String(finding.askOllie.question).trim(),
      checkId: finding.checkId,
      entryPoint: page || 'feature_page',
      finding,
    }
  }

  const fromMap =
    fallback || (page ? OLLIE_CONTEXTUAL_ASK_FALLBACKS[page] : null) || null
  const question = String(fromMap?.question || '').trim()
  if (!question) return null
  return {
    label,
    question,
    checkId: null,
    entryPoint: fromMap.entryPoint || page || 'feature_page',
    finding: null,
  }
}
